(function () {
  if (window.__ptUp) return;
  window.__ptUp = 1;

  var drawer = null, tab = 'care', building = false, timer = null, lastSig = '';

  var CSS = '.ptu{margin:1.6rem 0 2rem;padding:1.4rem;border-radius:2rem;background:#F7F4EC;border:1px solid rgba(20,50,31,.08)}'
    + '.ptu__head strong{display:block;font-family:var(--font-heading-family);font-weight:500;font-size:1.9rem;color:#14321F;margin-bottom:1rem}'
    + '.ptu__tabs{display:flex;flex-wrap:wrap;gap:.6rem;margin-bottom:1.2rem}'
    + '.ptu__tabs button{font:inherit;font-size:1.3rem;font-weight:600;min-height:4.4rem;padding:0 1.4rem;border-radius:999px;border:1.5px solid rgba(20,50,31,.2);background:#fff;color:#14321F;cursor:pointer}'
    + '.ptu__tabs button.is-on{background:#14321F;color:#FBF8F1;border-color:#14321F}'
    + '.ptu__row{display:flex;align-items:center;gap:1.2rem;background:#fff;border-radius:1.8rem;padding:.8rem;margin-bottom:.8rem}'
    + '.ptu__img{flex:none;width:6.4rem;height:6.4rem;border-radius:1.2rem;overflow:hidden;background:#F4F1E8;display:block}'
    + '.ptu__img img{width:100%;height:100%;object-fit:contain;mix-blend-mode:multiply;display:block}'
    + '.ptu__info{flex:1;min-width:0}'
    + '.ptu__t{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-family:var(--font-heading-family);font-size:1.5rem;line-height:1.25;color:#14321F;text-decoration:none;margin-bottom:.3rem}'
    + '.ptu__p{margin:0;display:flex;gap:.6rem;align-items:baseline;font-size:1.4rem}'
    + '.ptu__p b{color:#14321F}.ptu__p s{font-size:1.2rem;color:rgba(27,42,32,.68)}'
    + '.ptu__add{flex:none;width:4.4rem;height:4.4rem;border-radius:50%;border:0;background:#D9A441;color:#14321F;display:grid;place-items:center;cursor:pointer;text-decoration:none;font-size:2rem;transition:transform .15s,background .25s}'
    + '.ptu__add:active{transform:scale(.94)}'
    + '.ptu__add svg{width:2rem;height:2rem;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}'
    + '.ptu__add .ck{display:none}.ptu__add.is-done{background:#14321F;color:#FBF8F1}.ptu__add.is-done .pl{display:none}.ptu__add.is-done .ck{display:block}.ptu__add.is-busy{opacity:.6}';

  function injectCss() {
    if (document.getElementById('ptu-css')) return;
    var s = document.createElement('style');
    s.id = 'ptu-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function money(n) { return '\u20b9' + Math.round(n).toLocaleString('en-IN'); }
  function sized(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160' : ''; }

  function fromCollection(p) {
    var vs = p.variants || [], v = null, i;
    for (i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
    if (!v) return null;
    var price = parseFloat(v.price), cmp = parseFloat(v.compare_at_price || 0);
    return { id: p.id, title: p.title, url: '/products/' + p.handle, img: p.images && p.images[0] ? p.images[0].src : '', price: price, cmp: cmp > price ? cmp : 0, vid: v.id, multi: vs.length > 1 };
  }
  function fromRec(p) {
    if (!p.available) return null;
    var vs = p.variants || [], v = null, i;
    for (i = 0; i < vs.length; i++) { if (vs[i].available) { v = vs[i]; break; } }
    if (!v) return null;
    var price = p.price / 100, cmp = (p.compare_at_price || 0) / 100;
    var img = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image && p.featured_image.url) || '';
    return { id: p.id, title: p.title, url: p.url ? p.url.split('?')[0] : '/products/' + p.handle, img: img, price: price, cmp: cmp > price ? cmp : 0, vid: v.id, multi: vs.length > 1 };
  }

  function load(cart) {
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var last = cart.items[cart.items.length - 1];
    var pCare = fetch('/collections/plant-care/products.json?limit=24').then(function (r) { return r.json(); })
      .then(function (d) { return (d.products || []).map(fromCollection).filter(Boolean); }).catch(function () { return []; });
    var pSim = fetch('/recommendations/products.json?product_id=' + last.product_id + '&limit=10&intent=related').then(function (r) { return r.json(); })
      .then(function (d) { return (d.products || []).map(fromRec).filter(Boolean); }).catch(function () { return []; });
    return Promise.all([pCare, pSim]).then(function (a) {
      function f(list) { return list.filter(function (x) { return !inCart[x.id]; }).slice(0, 4); }
      return { care: f(a[0]), sim: f(a[1]) };
    });
  }

  function rows(list) {
    return list.map(function (x) {
      var action = x.multi
        ? `<a class='ptu__add' href='${x.url}' aria-label='Choose options for ${esc(x.title)}'>&rarr;</a>`
        : `<button type='button' class='ptu__add' data-up-add='${x.vid}' aria-label='Add ${esc(x.title)} to cart'><svg class='pl' viewBox='0 0 24 24' aria-hidden='true'><path d='M12 5v14M5 12h14'/></svg><svg class='ck' viewBox='0 0 24 24' aria-hidden='true'><path d='M5 12.5l4.5 4.5L19 7.5'/></svg></button>`;
      return `<div class='ptu__row'><a class='ptu__img' href='${x.url}' tabindex='-1' aria-hidden='true'>${x.img ? `<img src='${sized(x.img)}' alt='' loading='lazy' width='160' height='160'>` : ''}</a><div class='ptu__info'><a class='ptu__t' href='${x.url}'>${esc(x.title)}</a><p class='ptu__p'><b>${money(x.price)}</b>${x.cmp ? `<s>${money(x.cmp)}</s>` : ''}</p></div>${action}</div>`;
    }).join('');
  }

  function build(data) {
    var has = { care: data.care.length > 0, sim: data.sim.length > 0 };
    if (!has.care && !has.sim) return null;
    if (!has[tab]) tab = has.care ? 'care' : 'sim';
    var el = document.createElement('div');
    el.id = 'pt-upsell';
    el.className = 'ptu';
    el.innerHTML = `<div class='ptu__head'><strong>Complete your order</strong><div class='ptu__tabs'>`
      + (has.care ? `<button type='button' data-t='care' class='${tab === 'care' ? 'is-on' : ''}'>Care essentials</button>` : '')
      + (has.sim ? `<button type='button' data-t='sim' class='${tab === 'sim' ? 'is-on' : ''}'>Similar plants</button>` : '')
      + `</div></div><div class='ptu__list'>${rows(data[tab])}</div>`;
    el._data = data;
    return el;
  }

  function mount() {
    if (!drawer || !drawer.classList.contains('active')) return;
    var items = drawer.querySelectorAll('.cart-item');
    var host = drawer.querySelector('cart-drawer-items');
    var existing = drawer.querySelector('#pt-upsell');
    if (!items.length || !host) { if (existing) existing.remove(); lastSig = ''; return; }
    var sig = [].map.call(items, function (i) { var n = i.querySelector('.cart-item__name'); return n ? n.textContent.trim() : i.id; }).join('|');
    if (existing && existing.parentNode === host && lastSig === sig) return;
    if (building) return;
    building = true;
    lastSig = sig;
    injectCss();
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items.length) return null;
      return load(cart);
    }).then(function (data) {
      building = false;
      var old = drawer.querySelector('#pt-upsell');
      if (old) old.remove();
      if (!data) return;
      var el = build(data);
      var h = drawer.querySelector('cart-drawer-items');
      if (el && h) h.appendChild(el);
    }).catch(function () { building = false; });
  }

  function init() {
    drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var queue = function () { clearTimeout(timer); timer = setTimeout(mount, 250); };
    new MutationObserver(queue).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    drawer.addEventListener('click', function (e) {
      var t = e.target.closest('[data-t]');
      if (t && t.closest('#pt-upsell')) {
        var box = t.closest('#pt-upsell');
        tab = t.getAttribute('data-t');
        [].forEach.call(box.querySelectorAll('[data-t]'), function (b) { b.classList.toggle('is-on', b === t); });
        box.querySelector('.ptu__list').innerHTML = rows(box._data[tab]);
        return;
      }
      var a = e.target.closest('[data-up-add]');
      if (!a || a.disabled) return;
      a.disabled = true;
      a.classList.add('is-busy');
      var fd = new FormData();
      fd.append('id', a.getAttribute('data-up-add'));
      fd.append('quantity', '1');
      if (drawer.getSectionsToRender) {
        fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      }
      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw res;
          a.classList.add('is-done');
          if (drawer.renderContents) drawer.renderContents(res); else window.location.reload();
        })
        .catch(function () { a.disabled = false; a.classList.remove('is-busy'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
